import Breadcrumb from '../Components/Breadcrumb';
import SEO from '../Components/SEO';

export default function PrivacyPolicy() {
    return (
        <div>
            <SEO
                title='Privacy Policy | English Exam Exercises'
                description='Learn how English Exam Exercises collects, uses, and protects your personal information.'
                name='English Exam Exercises'
                type='article' />
            <Breadcrumb />

            <div className="grammar-container">
                <div className="exercises-container div1">
                    <div className='homebodytext'>
                        <img src="/Images/privacy-policy.webp" alt="Privacy Policy" />
                        <section>
                            <h2>Privacy Policy</h2>
                            <p><strong>Last updated:</strong> September 20, 2026</p>

                            <h3>1. Information We Collect</h3>
                            <p>We collect information you provide directly to us, such as when you fill out a contact form, subscribe to a newsletter, or interact with our exercises. This may include your name, email address, and any message content.</p>

                            <h3>2. Automatic Data Collection</h3>
                            <p>When you visit our site, we automatically collect certain information about your device and usage through cookies and similar technologies. This includes your IP address, browser type, pages visited, and time spent on pages. We use Google Analytics and Google AdSense, which may place cookies on your device to analyze traffic and serve personalized ads.</p>

                            <h3>3. How We Use Your Information</h3>
                            <ul>
                                <li>To provide and improve our English learning exercises</li>
                                <li>To respond to your inquiries and provide support</li>
                                <li>To send periodic emails (if you subscribed)</li>
                                <li>To display relevant advertisements via Google AdSense</li>
                                <li>To analyze site usage and improve user experience</li>
                            </ul>

                            <h3>4. Cookies and Tracking Technologies</h3>
                            <p>Our site uses cookies for essential functionality, analytics, and advertising. Google AdSense uses the DoubleClick cookie to serve ads based on your visit to our site and other sites. You can opt out of personalized ads by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">Google Ads Settings</a> or <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">aboutads.info</a>.</p>

                            <h3>5. Third-Party Services</h3>
                            <p>We use the following third-party services that may collect data:</p>
                            <ul>
                                <li>Google Analytics — site analytics</li>
                                <li>Google AdSense — advertising</li>
                                <li>Google Fonts — font loading</li>
                                <li>Bootstrap CDN — styling framework</li>
                            </ul>

                            <h3>6. Data Retention</h3>
                            <p>We retain personal information only as long as necessary for the purposes outlined in this policy, unless a longer retention period is required by law.</p>

                            <h3>7. Your Rights</h3>
                            <p>Depending on your location, you may have rights under data protection laws (such as GDPR or CCPA) including the right to access, correct, delete, or restrict processing of your personal data. To exercise these rights, contact us via the <a href="/contact">Contact page</a>.</p>

                            <h3>8. Children's Privacy</h3>
                            <p>Our site is not directed to children under 13. We do not knowingly collect personal information from children under 13. If you believe we have collected such information, please contact us immediately.</p>

                            <h3>9. Changes to This Policy</h3>
                            <p>We may update this Privacy Policy from time to time. We will post any changes on this page with an updated "Last updated" date.</p>

                            <h3>10. Contact Us</h3>
                            <p>If you have questions about this Privacy Policy, please visit our <a href="/contact">Contact page</a>.</p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}